import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the async thunk
export const fetchJobHistory = createAsyncThunk(
  'history/fetchJobHistory',
  async (_, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      // console.log('Token:', ticketToken); // Verify the token is being retrieved correctly

      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/get-job-history`,
        {}, {
        headers: {
          'Authorization': `Bearer ${ticketToken}`, // Add the token to the request headers
        },
      });
      console.log('Response:', response.data); // Log the response data
      return response.data.data; // Extract the data array
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Define the async thunk for deleting a job from history
export const deleteJobFromHistory = createAsyncThunk(
  'history/deleteJobFromHistory',
  async (jobId, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/delete-job-from-history`,
        { jobId: jobId }, {
        headers: {
          'Authorization': `Bearer ${ticketToken}`,
        },
      });
      return jobId; // Return the job ID after successful deletion
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  historyData: [], // Ensure this is an array
  loading: false,
  error: null,
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    clearHistory: (state) => {
      state.historyData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.historyData = action.payload;
      })
      .addCase(fetchJobHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteJobFromHistory.fulfilled, (state, action) => {
        state.historyData = state.historyData.filter(item => item._id !== action.payload);
      })
      .addCase(deleteJobFromHistory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default historySlice.reducer;
export const { clearHistory } = historySlice.actions;
